<div class="row">
    <div class="col-md-8">
        <h5 class="font-weight-bold">&nbsp;&nbsp;{{formTitle}}</h5>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button" (click)="onBack()">Back</button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-5">
        <div class="card-body">
            <h5 class="card-title font-weight-bold font-size-lg mb-4">Personal Info</h5>
            <form [formGroup]="empForm">
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group"><label for="fname">First Name *
                            </label><input id="fname" class="form-control" formControlName="fname" placeholder="First Name" type="text" [ngClass]="{'is-invalid': submitted && f.fname.errors}">
                            <div *ngFor="let validation of validation_messages.fname">
                                <div class="error-message" *ngIf="f.fname.hasError(validation.type) && ((f.fname.dirty || f.fname.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group"><label for="lname">Last Name *
                            </label><input id="lname" class="form-control" formControlName="lname" placeholder="Last Name" type="text" [ngClass]="{'is-invalid': submitted && f.lname.errors}">
                            <div *ngFor="let validation of validation_messages.lname">
                                <div class="error-message" *ngIf="f.lname.hasError(validation.type) && 
                                                                        ((f.lname.dirty || f.lname.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <div class=" form-group"><label for="email">Email *
                            </label><input id="email" class="form-control" [readonly]="isEditMode"  formControlName="email" placeholder="Email" type="text" [ngClass]="{'is-invalid': submitted && f.email.errors}">
                            <div *ngFor="let validation of validation_messages.email">
                                <div class="error-message" *ngIf="f.email.hasError(validation.type) && 
                                                                ((f.email.dirty || f.email.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12" *ngIf="!isEditMode">
                        <div class=" form-group">
                            <label for="password">Password *</label>
                            <div class="input-group">
                                <input id="password" class="form-control" [type]="!hide ? 'password' : 'text'" readonly formControlName="password" placeholder="Enter your password" required [ngClass]="{'is-invalid': submitted && f.password.errors}">
                                <div class="input-group-append">
                                    <span class="input-group-text" style="padding: 0rem 1rem !important;">
                                        <mat-icon class="placeholder" *ngIf="hide" tooltip="Hide password"
                                            (click)="myFunction()">
                                            {{'visibility_off'}}
                                        </mat-icon>
                                        <mat-icon class="placeholder" *ngIf="!hide" tooltip="Show password"
                                            (click)="myFunction()">
                                            {{ 'visibility'}}
                                        </mat-icon>
                                    </span>
                                </div>
                            </div>
                            <div *ngFor="let validation of validation_messages.password">
                                <div class="error-message" *ngIf="f.password.hasError(validation.type) &&  ((f.password.dirty || f.password.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="colo-xl-4 col-md-6 col-sm-12" *ngIf="isEditMode">
                        <div class="position-relative form-group">
                            <label for="status">Status *</label>
                            <ng-select id="status" formControlName="status" [(ngModel)]="selectedStatus" placeholder="Select status" [ngClass]="{'is-invalid': submitted && f.status.errors}">
                                <ng-option *ngFor="let s of status" [value]="s">{{s}} </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.status">
                                <div class="error-message" *ngIf="f.status.hasError(validation.type) && 
                                                                        ((f.status.dirty || f.status.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 py-3">
                        <button id="saveTeamMemberBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onAddEmployee(empForm.value)" *ngIf="!isEditMode">Add Admin</button>
                        <button id="updateTeamMemberBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onUpdateEmployee(empForm.value)" *ngIf="isEditMode">Update Admin</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>
